module.exports = __webpack_public_path__ + "static/media/favicon.d106401e.io";